module.exports = __webpack_public_path__ + "static/media/sidewalk_labs.bb2c2e7c.jpg";